/* istanbul ignore file */
import React from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import styled from 'styled-components';
import SahamDrawer from 'components/SahamDrawer';
import { translate } from 'containers/services/translate';
import messages from 'containers/PreOpeningPage/messages';
import { Vehicule } from 'containers/PreOpeningPage/typings';
import OpposingPartyForm from 'containers/PreOpeningPage/OpposingParty/OpposingPartyForm';
import { Listings } from 'containers/AppContainer/typings';
import { PARTIES_CLAIM_STATUS, VEHICULE } from 'containers/data-structure';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import recapManagerMessages from 'containers/RecapManagerPage/messages';
import { get, isEmpty, isNull } from 'lodash';
import userPrivileges, {
  PRIVILEGES,
} from 'containers/services/security/user-privileges';
import { toast } from 'react-toastify';
import { rcCoporeal } from 'containers/CourtManagerLegalProceedings/constants';
import { resolveSagisClaim } from 'helpers/utils';
import { getRiskIdFromPolicyInfo } from 'containers/CourtManagerLegalProceedings/utils';
import validate from 'containers/services/validateForm';
import { validateFormFields } from 'containers/services/validateForm';
import {
  getFormContraints,
  validateRegistrationNumber,
  getInputLength,
  isAllInputsLengthValid,
  renderInputLengthErrorText,
  formatRegistrationNumber,
} from 'containers/PreOpeningPage/OpposingParty/utils';

export interface OpposingPartyDrawerProps {
  intl: IntlShape;
  open: boolean;
  handleToggleDrawer: Function;
  vehicule: Vehicule;
  listings: Listings;
  setVehicule: Function;
  setClaimRecap?: Function;
  vehiculeIndex: number;
  data: any;
  requestUpdateVehicleInfo?: Function;
  policyInfo?: { sagis: {} };
  setOpposingPartyData?: Function;
  opposingPartyData?: any;
  setDataClaimToUpdate?: Function;
  dataClaimToUpdate?: any;
  sagisOpposingParties: any;
}
const Container = styled.div`
  .fields {
    display: flex;
    flex-direction: column;
    margin-top: 10px;
    margin-bottom: 10px;
    height: 500px;
  }
  .input {
    width: 327px;
    margin-bottom: 20px;
    margin-left: 24px;
    margin-right: 24px;
  }
`;

const OpposingPartyDrawer: React.FC<OpposingPartyDrawerProps> = ({
  listings,
  setVehicule,
  ...props
}): JSX.Element => {
  let [data, setData] = React.useState<any>({});
  let [opposingPartySagis, setOpposingPartySagis] = React.useState<any>({});
  const [
    isRegistrationNumberValid,
    setIsRegistrationNumberValid,
  ] = React.useState<Boolean>(true);
  const [
    registrationNumberErrorText,
    setRegistrationNumberErrorText,
  ] = React.useState<String>('');
  const [inputsLengthErrorText, setInputsLengthErrorText] = React.useState<{
    [VEHICULE.POLICY_NUMBER_OPPOSING]: String;
    [VEHICULE.CERTIFICATE_NUMBER_OPPOSING]: String;
    [VEHICULE.CLAIM_NUMBER_OPPOSING]: String;
  }>({
    [VEHICULE.POLICY_NUMBER_OPPOSING]: '',
    [VEHICULE.CERTIFICATE_NUMBER_OPPOSING]: '',
    [VEHICULE.CLAIM_NUMBER_OPPOSING]: '',
  });
  const [formValidator, setFormValidator] = React.useState<any>({});
  React.useEffect(() => {
    setData({ ...props.data });
    if (!isEmpty(get(props.policyInfo, 'sagis.claims'))) {
      const { vehicules } = props.data;
      const sagisOpposingParties = get(
        resolveSagisClaim(props.policyInfo),
        'offeredRisks',
        [],
      ).find((element: { riskName: string }) => element.riskName === rcCoporeal)
        ?.opposingParties;
      const corpoVehicle = get(props.policyInfo, 'corporeal[0].vehicules');

      const selectedCorpoVehicle = get(
        corpoVehicle,
        `[${props.vehiculeIndex}]`,
      );
      let filtredSagisOpposingParty: {
        partyKey: any;
        RiskID: any;
        firstName: string;
        lastName: string;
      };
      filtredSagisOpposingParty =
        selectedCorpoVehicle &&
        sagisOpposingParties?.find(
          (element: {
            registrationNumber: string;
            insuranceCompanyCode: string;
          }) =>
            element.registrationNumber ===
              selectedCorpoVehicle?.registrationNumber &&
            element.insuranceCompanyCode ===
              selectedCorpoVehicle?.opposingParty,
        );
      setOpposingPartySagis(filtredSagisOpposingParty);
      if (filtredSagisOpposingParty) {
        const index = props.vehiculeIndex;
        vehicules[index][VEHICULE.FIRST_NAME] =
          filtredSagisOpposingParty?.firstName;
        vehicules[index][VEHICULE.LAST_NAME] =
          filtredSagisOpposingParty?.lastName;
        setData({ ...props.data, vehicules });
      }
    }
  }, []);
  let vehicule = get(data, `vehicules[${props.vehiculeIndex}]`);
  const handleChange = (field: string) => (
    event: React.ChangeEvent<{
      name?: string;
      value?: any;
    }>,
    valueField?: any,
  ) => {
    const { value } = event.target;
    const index = props.vehiculeIndex;
    const { vehicules } = data;
    if (setVehicule && vehicules) {
      switch (field) {
        case VEHICULE.BRAND:
          vehicules[index][VEHICULE.BRAND] = valueField?.ItemKey;
          break;
        case VEHICULE.LAST_NAME:
        case VEHICULE.FIRST_NAME:
        case VEHICULE.OPPOSING_PARTY:
          vehicules[index][field] = value;
          break;
        case VEHICULE.REGISTRATION_NUMBER_TYPE:
        case VEHICULE.REGISTRATION_NUMBER:
          vehicules[index][field] = value;
          if (featureService.hasFeature(FEATURES.RNVA)) {
            const error = validateRegistrationNumber(
              vehicules[index][VEHICULE.REGISTRATION_NUMBER],
              vehicules[index][VEHICULE.REGISTRATION_NUMBER_TYPE],
              props,
            );
            setRegistrationNumberErrorText(error);
            setIsRegistrationNumberValid(!error);
          } else {
            const pattern = /^(?:\d{1,5}-[a-zA-Z]{1,2}-\d{1,2}|[a-zA-Z]-\d{1,9}|\d{1,2}-\d{1,6}|\d{1,5}-\d{1,2}|\d{1,5}-\d{1,2}-\d{1,2}|WW\d{1,6}|W18-\d{1,6})$/;
            setIsRegistrationNumberValid(pattern.test(value));
          }
          break;
        case VEHICULE.POLICY_NUMBER_OPPOSING:
        case VEHICULE.CERTIFICATE_NUMBER_OPPOSING:
        case VEHICULE.CLAIM_NUMBER_OPPOSING:
          const maxLength =
            field === VEHICULE.CERTIFICATE_NUMBER_OPPOSING ? 30 : 20;
          vehicules[index][field] = value;
          setInputsLengthErrorText({
            ...inputsLengthErrorText,
            [field]: renderInputLengthErrorText(
              3,
              maxLength,
              getInputLength(value),
              props,
            ),
          });
          break;
        case VEHICULE.RESPONSABILITY:
          const selectedItem = get(listings, 'responsability', []).find(
            (el: any) => el.ItemKey === value,
          );
          vehicules[index][VEHICULE.RESPONSABILITY] = value;
          vehicules[index][VEHICULE.RESPONSABILITY_RATE] =
            selectedItem?.ItemDescription;
          break;
        default:
          return vehicules;
      }

      setData({ ...data, vehicules });
    }
  };
  const successCallBackUpdateVehicle = () => {
    toast.success(translate(messages.successUpdateVehicle, props));
  };
  const handleSubmitEdit = () => {
    if (featureService.hasFeature(FEATURES.RNVA)) {
      vehicule = {
        ...vehicule,
        [VEHICULE.REGISTRATION_NUMBER]: formatRegistrationNumber(
          vehicule[VEHICULE.REGISTRATION_NUMBER],
          vehicule[VEHICULE.REGISTRATION_NUMBER_TYPE],
        ),
      };
      let { vehicules } = data;
      const index = props.vehiculeIndex;
      vehicules[index] = { ...vehicule };
      setData({ ...data, vehicules });
    }

    const formConstraints = getFormContraints();
    const validator = validate(vehicule, formConstraints);
    setFormValidator(validator);
    const hasInputhLengthError = isAllInputsLengthValid(inputsLengthErrorText);
    if (
      validateFormFields(validator) &&
      isRegistrationNumberValid &&
      hasInputhLengthError
    ) {
      const riskId = getRiskIdFromPolicyInfo(props.policyInfo);
      if (props.setOpposingPartyData) {
        props.setOpposingPartyData([
          ...get(data, 'vehicules', []),
          ...props.opposingPartyData.filter((el: any) => !el.id),
        ]);
      }
      vehicule['isModified'] = true;
      if (props.setDataClaimToUpdate) {
        props.setDataClaimToUpdate({
          ...props.dataClaimToUpdate,
          vehicules: [
            ...get(data, 'vehicules', []),
            ...props.opposingPartyData.filter((el: any) => !el.id),
          ],
        });
      }
      if (props.setClaimRecap) {
        props.setClaimRecap({
          ...data,
          vehicules: [
            ...get(data, 'vehicules', []),
            ...props.opposingPartyData.filter((el: any) => !el.id),
          ],
        });
      }
      const decisionVehicule =
        !isNull(get(vehicule, 'decision')) &&
        get(vehicule, 'decision.status') !== PARTIES_CLAIM_STATUS.VALIDATED;
      if (
        props.requestUpdateVehicleInfo &&
        (opposingPartySagis || decisionVehicule) &&
        userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMONITORINGMANAGER)
      ) {
        props.requestUpdateVehicleInfo(
          decisionVehicule
            ? {
                ...vehicule,
                updateDecisionVehicle: decisionVehicule,
                decisionVehicle: {
                  id: get(vehicule, 'decision.id'),
                  status: PARTIES_CLAIM_STATUS.PENDING,
                  reason: null,
                },
                insuranceCompanyCode: vehicule?.opposingParty,
                partyKey: opposingPartySagis?.partyKey,
                isTrackingActive: featureService.hasFeature(
                  FEATURES.TRACKING_ACTIONS_USER,
                ),
                riskID: String(riskId),
              }
            : {
                ...vehicule,
                updateDecisionVehicle: decisionVehicule,
                insuranceCompanyCode: vehicule?.opposingParty,
                partyKey: opposingPartySagis?.partyKey,
                isTrackingActive: featureService.hasFeature(
                  FEATURES.TRACKING_ACTIONS_USER,
                ),
                riskID: String(riskId),
              },
          successCallBackUpdateVehicle,
        );
      }
      setVehicule(vehicule);
      props.handleToggleDrawer();
    }
  };
  return (
    <SahamDrawer
      open={props.open}
      handleToggleDrawer={() => props.handleToggleDrawer(null, true)}
      title={translate({ ...messages.opposingPartyCardTitle }, props)}
      confirmButtonTitle={translate(
        recapManagerMessages.drawerSaveFormButtonTitle,
        props,
      )}
      handleValidateDrawer={handleSubmitEdit}
    >
      <Container>
        <div className="fields">
          <OpposingPartyForm
            vehicule={
              {
                ...vehicule,
              } as Vehicule
            }
            customClass="input"
            setCurrentVehicule={setVehicule}
            handleChange={handleChange}
            isRegistrationNumberValid={isRegistrationNumberValid}
            registrationNumberErrorText={registrationNumberErrorText}
            listings={listings}
            isForDrawer={false}
            sagisOpposingParties={props.sagisOpposingParties}
            formValidator={formValidator}
            inputsLengthErrorText={inputsLengthErrorText}
          />
        </div>
      </Container>
    </SahamDrawer>
  );
};

export default injectIntl(OpposingPartyDrawer);
